import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '@ion/iam';

/**
 * Guard that only allows navigation while Cognito waits for the code sent by e-mail.
 * Otherwise redirects to the home page.
 */
export const isEmailCodeRequiredGuard = (): boolean | UrlTree => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (authService.emailCodeRecipient() !== null) {
    return true;
  }

  return router.createUrlTree(['/']);
};
